import ConfirmDeleteModal from './ConfirmationModal';

export default ConfirmDeleteModal;
